export default __webpack_public_path__ + "static/2-3cf6f312ce77d7f9ad5f8f838fba22e2.png";